import { useCallback, useState } from 'react';
import type { SliderProps } from './provider';
import type { RangeValue, SingleValue } from './types';

export const useSlider = <T extends boolean>({
  min,
  max,
  value: controlledValue,
  defaultValue,
  onChange,
  isRange,
}: SliderProps<T>) => {
  const [internalValue, setInternalValue] = useState<T extends true ? RangeValue : SingleValue>(
    defaultValue ?? ((isRange ? [min, max] : min) as T extends true ? RangeValue : SingleValue)
  );

  const isControlled = controlledValue !== undefined;
  const value = isControlled ? controlledValue : internalValue;

  const handleChange = useCallback(
    (newValue: typeof value) => {
      if (!isControlled) {
        setInternalValue(newValue);
      }
      if (onChange) {
        onChange(newValue);
      }
    },
    [isControlled, onChange]
  );

  return { value, handleChange };
};
